import React from 'react';
import PropTypes from 'prop-types';
import { ForgeCircularProgress, ForgeIcon } from '@tylertech/forge-react';
import { messageManager } from '../../System/messageManager/messageManager.js';
import './GeneratedDocumentsMenuItems.scss';
import { getFileName } from './documentsHelpers.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';

const MenuItemLoading = ({ document }) => {
  const { nameConventions } = useNameConventions();

  return (
    <li className="menuItem">
      <div className="name-and-date-container">
        <ForgeIcon external externalType="all" className="opacity54" name={getFileName(document.documentName)} />
        <div>
          <p className="noMargin opacity87">{document.documentName}</p>
          <p className="noMargin forge-typography--body2 opacity54">{messageManager(nameConventions).DOCUMENT_GENERATOR.GENERATING_REPORT}</p>
        </div>
      </div>
      <ForgeCircularProgress track className="circular-progress" />
    </li>
  );
};

MenuItemLoading.propTypes = {
  document: PropTypes.object,
};

export default MenuItemLoading;
